import React, { useRef, useState, useEffect } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import BlockUi from 'react-block-ui';
import useMonitorAPIService from '../../services/monitorapiservice';
import { Switch } from "devextreme-react";
import { SelectBox } from 'devextreme-react/select-box';
import { NumberBox } from "devextreme-react/number-box";
import Toastr from '../utils/toastr';
import { setConfig } from '../../redux/parametersSlice';

function Config(props) {

    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const toastrRef = useRef(null);

    const [showDisconnectedAgents, setShowDisconnectedAgents] = useState(false);
    const [hideMissedOnWelcome, setHideMissedOnWelcome] = useState(false);
    const [hideMissedOnQueue, setHideMissedOnQueue] = useState(false);
    const [onlyOpengroupCalls, setOnlyOpengroupCalls] = useState(false);
    const [showCalls, setShowCalls] = useState(0);
    const [refreshTime, setRefreshTime] = useState(0);

    const { updateMonitorSettings } = useMonitorAPIService();

    useEffect(() => {
        setShowDisconnectedAgents(props.showDisconnectedAgents);
        setHideMissedOnWelcome(props.hideMissedOnWelcome);
        setHideMissedOnQueue(props.hideMissedOnQueue);
        setOnlyOpengroupCalls(props.onlyOpengroupCalls);
        setShowCalls(props.showOnly);
        setRefreshTime(props.refreshTime);
    }, [props]);

    const data = [
        { id: 0, text: t("all") },
        { id: 1, text: t("fidelityandexternal") },
        { id: 2, text: t("onlyfidelity") }
    ];




    const setMonitorSettings = e => {
        setLoading(true);

        let data = {
            showDisconnectedAgents: showDisconnectedAgents,
            hideMissedOnWelcome: hideMissedOnWelcome,
            hideMissedOnQueue: hideMissedOnQueue,
            onlyOpengroupCalls: onlyOpengroupCalls,
            showOnly: showCalls,
            refreshTime: refreshTime
        };

        updateMonitorSettings(props.token, data, (res) => {

            if (!res) {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("error"));
                toastrRef.current.show();
            } else {
                toastrRef.current.setType("success");
                toastrRef.current.setMessage(t("dataupdated"));
                toastrRef.current.show();
                props.setConfig(data);
                props.toggleModal();
            }

            setLoading(false);
        });

    }
    return (<>
        <Modal show={props.show} onHide={props.toggleModal} size="lg">
            <BlockUi tag="div" blocking={loading} color="#009ef7" message={t("pleasewait")}>
                <Modal.Header>
                    <Modal.Title><FontAwesomeIcon icon={duotone("cog")} /> {t("config")}</Modal.Title>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {t("close")}
                        </Tooltip>}>
                        <Button onClick={props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <Row className='py-4'>
                        <Col lg={8}><Form.Label htmlFor='showdisconnectedagents'>{t("showdisconnectedagents")}</Form.Label></Col>
                        <Col lg={4}> <Switch id='showdisconnectedagents' rtlEnabled={props.rtl} switchedOnText={t("yes")} switchedOffText={t("no")} value={showDisconnectedAgents} onValueChange={setShowDisconnectedAgents} text /></Col>
                    </Row>
                    <Row className='py-4'>
                        <Col lg={8}><Form.Label htmlFor='hidemissedonwelcome'>{t("hidemissedonwelcome")}</Form.Label></Col>
                        <Col lg={4}><Switch id='hidemissedonwelcome' rtlEnabled={props.rtl} switchedOnText={t("yes")} switchedOffText={t("no")} value={hideMissedOnWelcome} onValueChange={setHideMissedOnWelcome} text /></Col>
                    </Row>
                    <Row className='py-4'>
                        <Col lg={8}><Form.Label htmlFor='hidemissedonqueue'>{t("hidemissedonqueue")}</Form.Label></Col>
                        <Col lg={4}><Switch id='hidemissedonqueue' rtlEnabled={props.rtl} switchedOnText={t("yes")} switchedOffText={t("no")} value={hideMissedOnQueue} onValueChange={setHideMissedOnQueue} text /></Col>
                    </Row>
                    <Row className='py-4'>
                        <Col lg={8}><Form.Label htmlFor='onlyopengroupcalls'>{t("onlyopengroupcalls")}</Form.Label></Col>
                        <Col lg={4}><Switch id='onlyopengroupcalls' rtlEnabled={props.rtl} switchedOnText={t("yes")} switchedOffText={t("no")} value={onlyOpengroupCalls} onValueChange={setOnlyOpengroupCalls} text /></Col>
                    </Row>
                    <Row className='py-4'>
                        <Col lg={8}><Form.Label htmlFor='showcalls'>{t("showcalls")}</Form.Label></Col>
                        <Col lg={4}>
                            <SelectBox
                                id='showcalls'
                                rtlEnabled={props.rtl}
                                dataSource={data}
                                value={showCalls}
                                onValueChange={setShowCalls}
                                valueExpr="id"
                                displayExpr="text"
                                dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                            />
                        </Col>
                    </Row>
                    <Row className='py-4'>
                        <Col lg={8}> <Form.Label htmlFor='refreshtime'>{t("refreshtime")}</Form.Label></Col>
                        <Col lg={4}>
                            <NumberBox
                                id='refreshtime'
                                rtlEnabled={props.rtl}
                                showSpinButtons={true}
                                value={refreshTime}
                                onValueChange={setRefreshTime} />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={setMonitorSettings}>
                        <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {t("send")}
                    </Button>
                </Modal.Footer>
            </BlockUi>
        </Modal>
        <Toastr ref={toastrRef} />
    </>)
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        showDisconnectedAgents: state.parameters.showDisconnectedAgents,
        hideMissedOnWelcome: state.parameters.hideMissedOnWelcome,
        hideMissedOnQueue: state.parameters.hideMissedOnQueue,
        onlyOpengroupCalls: state.parameters.onlyOpengroupCalls,
        showOnly: state.parameters.showOnly,
        refreshTime: state.parameters.refreshTime,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, { setConfig })(Config);